var map = {
	"./example-00-a-music/game.js": 17629,
	"./example-00-mausart/game.js": 39580,
	"./example-01-kuehlschrank-memo/game.js": 29117,
	"./example-02-maus-alarm/game.js": 40426,
	"./example-03-zahlen-raten/game.js": 70529,
	"./example-04-luftballon-spiel/game.js": 44489,
	"./example-05-einmaleins/game.js": 39076,
	"./example-06-suchspiel/game.js": 44628,
	"./example-07-weltraum-abenteuer/game.js": 16182,
	"./example-08-schlaue-maus/game.js": 48118
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31349;